import 'twin.macro';
import React from 'react';
import { Body } from './Body';
import { useTranslation } from 'react-i18next';
import Dialog from 'components/Dialog';

interface Props {
  from: Date;
  to: Date;
  isOpen: boolean;
  onClose: () => void;
}

export function Volume(props: Props) {
  const { isOpen, onClose } = props;
  const { t } = useTranslation(['common', 'cahierJournal']);
  return (
    <Dialog
      size="md"
      isOpen={isOpen}
      title={t('cahierJournal:toolbar.volume.label')}
      closeButton
      onClose={onClose}
      position="top"
    >
      <Dialog.Body>
        <Body from={props.from} to={props.to} />
      </Dialog.Body>
    </Dialog>
  );
}
